import { CreateShippingRateTableInputSchema } from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { validationResponseSchema } from "./validation-schemas";

export const modifyShippingMethods = {
  name: "modifyShippingMethods" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingRateTablesToUpsert: z.array(
      z.object({
        id: z.union([
          z.object({ kind: z.literal("temporary"), value: z.string() }),
          z.object({ kind: z.literal("existing"), value: zExt.objectId() }),
        ]),
        createShippingRateTableInput: CreateShippingRateTableInputSchema,
      }),
    ),
    shippingRateTableIdsToDelete: z.array(zExt.objectId()),
    skipValidation: z.boolean().optional(),
  }),
  output: validationResponseSchema,
};
export type ModifyShippingMethodsInput = z.infer<
  typeof modifyShippingMethods.input
>;
